export default __webpack_public_path__ + "static/media/logo.ccad883d.png";